var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHighFiveLike = function SvgHighFiveLike(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#high-five-like_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 8.344v-2.85l-.969-2.66a.519.519 0 0 0-.568-.346.5.5 0 0 0-.38.662l1.262 3.468a.125.125 0 0 1-.177.153L1.19 6.107a.625.625 0 0 0-.712 1.02L3.577 9.77a3.38 3.38 0 0 1-.327-1.426ZM4.525 3.15a1.06 1.06 0 0 1 .814.772l.008.032.087.698.425-.757-1.015-2.792a.518.518 0 0 0-.57-.346.5.5 0 0 0-.38.663l.63 1.73ZM6.182 3.319l.643-1.144a.5.5 0 0 0-.7-.23.519.519 0 0 0-.213.631l.27.743ZM3.263 4.07a1.092 1.092 0 0 1 .738-.895L3.35 1.38a.519.519 0 0 0-.57-.346.5.5 0 0 0-.38.663l.864 2.373Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.397 5.154a.538.538 0 0 0-.65.235l-1.102 1.93a.25.25 0 0 1-.434-.249l1.97-3.45a.519.519 0 0 0-.103-.658.5.5 0 0 0-.752.139L8.342 6.575a.25.25 0 0 1-.434-.248l2.095-3.668A.52.52 0 0 0 9.899 2a.5.5 0 0 0-.752.14L7.04 5.829a.25.25 0 0 1-.434-.248l1.598-2.8a.519.519 0 0 0-.103-.656.5.5 0 0 0-.752.139L5.31 5.889a.125.125 0 0 1-.233-.046l-.225-1.797a.561.561 0 0 0-.591-.42.586.586 0 0 0-.513.595v4.12a2.871 2.871 0 0 0 1.447 2.482 3.065 3.065 0 0 0 4.202-1.055l2.231-3.908a.5.5 0 0 0-.232-.706Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "high-five-like_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHighFiveLike);
export default ForwardRef;